import { CssTextField } from "./CommonStyles";
function MultilineTextField({ id, label, value, onChange, inputProps = {} }) {
  const defaultInputProps = {
    style: { color: "black", fontWeight: "normal" },
  };
  const mergedInputProps = {
    ...defaultInputProps,
    ...inputProps, // user-provided maxLength/style override
  };

  const handleChange = (e) => {
    let newVal = e.target.value;
    if (mergedInputProps.maxLength && newVal.length > mergedInputProps.maxLength) {
      newVal = newVal.slice(0, mergedInputProps.maxLength);
    }
    onChange(newVal);
  };

  return (
    <CssTextField
      id={id}
      label={<span style={{ fontSize: 12 }}>{label}</span>}
      multiline
      rows={1}
      onChange={handleChange}
      value={value}
      inputProps={mergedInputProps}
      variant="standard"
      sx={{ marginLeft: 0, width: "100%" }}
    />
  );
}

export default MultilineTextField;
